import { z } from 'zod';
import {
  isHistoricFileReference,
  type HistoricFileReference,
} from '@/lib/camunda/form-file-values';
import type { MultiFileItem } from './multi-file-types';

const multiFileItemSchema = z.object({
  file: z.unknown().nullable().optional(),
  filename: z.string().optional(),
  id: z.string().optional(),
  tipo: z.string(),
  documentId: z.string().optional(),
  documentTitle: z.string().optional(),
  fileVariableName: z.string().optional(),
  notes: z.string().optional(),
  persisted: z.boolean().optional(),
  revision: z.number().optional(),
  historicReference: z.unknown().optional(),
});

export function normalizeMultiFileItems<TValue>(
  values: readonly TValue[],
): MultiFileItem[] {
  return values.flatMap(value => {
    const parsed = multiFileItemSchema.safeParse(value);
    if (!parsed.success) return [];

    const { file, historicReference: rawHistoricReference, ...item } = parsed.data;
    const historicReference: HistoricFileReference | undefined = isHistoricFileReference(
      rawHistoricReference,
    )
      ? rawHistoricReference
      : isHistoricFileReference(file)
        ? file
        : undefined;

    const normalizedItem: MultiFileItem = {
      ...item,
      file: file instanceof File ? file : null,
    };
    if (historicReference) {
      normalizedItem.historicReference = historicReference;
    }

    return [normalizedItem];
  });
}
